export default import.meta.ROLLDOWN_FILE_URL_iMXqnCr4coUxBI5W$nqJZA